import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ViewController } from 'ionic-angular';
import { DataService } from "../../services/data.service";
import {FormGroup} from "@angular/forms";
import {ReportAddUnitPage} from "../report-add-unit/report-add-unit";

@Component({
  selector: 'page-report-select-unitbrand',
  templateUrl: 'report-select-unitbrand.html',
})
export class ReportSelectUnitbrandPage {

  unitBrands = [];
  form: FormGroup;
  reportAddUnitPage: ReportAddUnitPage

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public viewCtrl: ViewController,
      public alertCtrl: AlertController,
      public dataService: DataService
  ) {
    this.form = navParams.get('form');
    if(navParams.get('reportAddUnitPage')){
      this.reportAddUnitPage = navParams.get('reportAddUnitPage');
    }
    this.dataService.getUnitBrands().then((data) => {
      // @ts-ignore
      this.unitBrands = data;
    }).catch((error) => {
      console.error(error);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportSelectUnitbrandPage');
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  select(item){
    this.form.get('unit_brand').setValue(item.title);
    this.form.get('unit_brand_id').setValue(item.unit_brand_id);
    this.form.get('unit_brand').markAsUntouched();
    this.form.get('unit_brand').markAsPristine();
    // Set allow warranty by unit_brand.waranty_status > 0
    if(this.reportAddUnitPage){
      if(parseInt(item.warranty_status) > 0){
        this.reportAddUnitPage.setAllowWarranty(true);
      } else {
        this.reportAddUnitPage.setAllowWarranty(false);
      }
    }
    this.closeModal();
  }

  selectOther(){
    this.alertCtrl.create({
      title: 'Ander merk',
      message: 'Vul de naam van het merk in:',
      inputs: [
        {
          name: 'unit_brand',
          placeholder: 'Merk'
        },
      ],
      buttons: [
        {
          text: 'Annuleren'
        },
        {
          text: 'Verder',
          handler: data => {
            if(data.unit_brand){
              this.form.get('unit_brand').setValue(data.unit_brand);
              this.form.get('unit_brand_id').setValue(0);
              this.form.get('unit_brand').markAsUntouched();
              this.form.get('unit_brand').markAsPristine();
              this.closeModal();
            } else {
              return false;
            }
          }
        }
      ]
    }).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/report-select-unitbrand/report-select-unitbrand.ts